import { DetailsMainPanel, DetailsSidePanel } from "components";
import { formatDataForDetailsMainPanel } from "helpers/DetailsPanelHelpers";
import { Tenant } from "models/tenant/Tenant";
import { Term } from "models/term/Term";
import { useMemo } from "react";
import "./styles.scss";

type BaseDetailsContentProps = {
	data: Tenant | { [key: string]: any };
	sidePanelFields?: string[];
	mainPanelFields: string[];
	mainPanelFieldNames: { [key: string]: string };
	showDefaultLinkNames?: boolean;
	isLoadingTerms?: boolean;
	terms?: Term[];
	availableTerms?: boolean;
};

export default function BaseDetailsContent(
	props: Readonly<BaseDetailsContentProps>
) {
	const {
		data,
		sidePanelFields,
		mainPanelFields,
		mainPanelFieldNames,
		showDefaultLinkNames,
		terms,
		availableTerms
	} = props;

	const formattedMainPanelData = useMemo(
		() =>
			formatDataForDetailsMainPanel(
				data,
				mainPanelFields,
				mainPanelFieldNames,
				showDefaultLinkNames
			),
		[
			data,
			sidePanelFields,
			mainPanelFields,
			mainPanelFieldNames,
			showDefaultLinkNames
		]
	);

	return (
		<div className="details-content">
			{sidePanelFields && (
				<DetailsSidePanel fields={sidePanelFields} data={data} />
			)}
			<DetailsMainPanel
				data={formattedMainPanelData}
				terms={terms}
				availableTerms={availableTerms}
			/>
		</div>
	);
}
